<ng-container *ngIf="!website.isNetwork || (website.isNetwork && website.parentId)">

<!-- Edit Button -->
    @if(!website.isNetwork && website.domain_hash){
        @if(needRedirectToRegenerate && website?.isWVC){
            <a class="db-website-item-actions__item mr5"
               (click)="redirectToRegenerate()"
               target="_blank" rel="noopener"
               [dsTooltip]="'text_editDesc' | dbText" dsTooltipAlign="left" dsTooltipSize="small">
                <i class="db-icon db-icon-ds-edit"></i>
            </a>
        } @else {
            <a class="db-website-item-actions__item mr5"
               dbWpLink
               [adminLink]="redirectUrl"
               [websiteId]="website?.id" target="_blank" rel="noopener"
               [dsTooltip]="'text_editDesc' | dbText" dsTooltipAlign="left" dsTooltipSize="small">
                <i class="db-icon db-icon-ds-edit"></i>
            </a>
        }
    }
  <!-- Website Preview -->
  <a *ngIf="!website?.isAiBuilderDemo" class="db-website-item-actions__item mr5"
     [href]="previewUrl" target="_blank" rel="noopener"
     [dsTooltip]="'text_wpFrontInfoDesc' | dbText" dsTooltipAlign="left" dsTooltipSize="small">
    <i class="db-icon db-icon-ds-eye"></i>
  </a>
  <!-- Website Preview end -->

<!-- WP Admin -->
  <ng-container *ngIf="user && website.isActive && !userSubscription?.trialClient">
    <a class="a db-website-item-actions__item mr5" *ngIf="website?.connectedFrom !== 'speed_optimizer'"
       dbWpLink [adminLink]="website?.adminUrl"
       [websiteId]="website?.id" target="_blank" rel="noopener"
       [dsTooltip]="WPAdminTooltipRef" dsTooltipAlign="left" dsTooltipSize="small">
      <i class="db-icon db-icon-ds-wordpress"></i></a>
  </ng-container>
  <a class="c db-website-item-actions__item mr5"
     *ngIf="user && website.isActive && userSubscription?.trialClient && !demoUser" dbWpLink
     [adminLink]="website?.adminUrl" [websiteId]="website?.id" target="_blank" rel="noopener"
     [dsTooltip]="WPAdminTooltipRef" dsTooltipAlign="left" dsTooltipSize="small">
    <i class="db-icon db-icon-ds-wordpress"></i></a>
<!-- WP Admin end -->


  <a *ngIf="currentWorkspace?.roleId !== clientRoles.SITE_DEV"
       class="db-website-item-actions__list-trigger" [dsTooltip]="actionsRef" dsTooltipMode="click"
       dsTooltipAlign="right" dsTooltipSize="small">
      <i class="db-icon db-icon-ds-more-l"></i></a>

</ng-container>
<ng-container *ngIf="website?.isNetwork && !website.parentId">
  <a class="db-website-item-actions__item" *ngIf="user && website.isActive"
     dbWpLink [adminLink]="website?.adminUrl" [websiteId]="childWebsiteId ? childWebsiteId : website.id"
     target="_blank" rel="noopener"
     [dsTooltip]="WPAdminTooltipRef" dsTooltipAlign="left" dsTooltipSize="small"><i
    class="db-icon db-icon-ds-sidebar-multisite"></i></a>

  <a *ngIf="website && !website.isAiBuilderDemo && currentWorkspace?.roleId !== clientRoles.SITE_DEV"
     class="db-website-item-actions__list-trigger" [dsTooltip]="actionsRef" dsTooltipMode="click"
     dsTooltipAlign="right" dsTooltipSize="small">
    <i class="db-icon db-icon-ds-more-l"></i></a>

</ng-container>

<ng-template #WPAdminTooltipRef>
  <p class="ds-tooltip-title"
     [innerHTML]="(!website.isNetwork || (website.isNetwork && website.parentId) ? 'text_wpAdminInfoTitle' : 'text_wpAdminInfoTitleMultisite') | dbText"></p>
  <p [innerHTML]="'text_wpAdminInfoDesc' | dbText"></p>
</ng-template>

<ng-template #actionsRef>
  <div class="db-website-item-actions__list" [ngClass]="{'disable': !!disableCopyWebsite || !!disableControls}">
    <p *ngIf="canClone" class="mb5" (click)="cloneWebsite()" [innerHTML]="'text_cloneWebsite' | dbText"></p>
    <p (click)="removeWebsite()" [innerHTML]="'text_removeDemoWebsite' | dbText"></p>
  </div>
</ng-template>
